import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { ProtoContactDto } from '../../contacts/dtos/proto-contact.dto';
import { ProtoDriverDto } from '../../drivers/dtos/proto-driver.dto';
import { AccountTypeEnum } from '../enums/account-type.enum';

/**
 * Create account DTO
 */
export class CreateAccountDto {
	color?: string;
	uuid!: string;
	email!: string;
	type!: AccountTypeEnum;
	contact!: ProtoContactDto;
	driver?: ProtoDriverDto;
	notes?: string;
	files?: FileDto[];
}
